import axios from "@/utils/request";

//轮播图
export function getbannerlist(params) {
  return axios.post("/banner/listts", params);
}

//资讯轮播图
export function getTimeInfo(params) {
  return axios.post("/bannerRealTimeInfo/listts", params);
}

//游戏ip管理
export function getgamelist(params) {
  return axios.post("/game/listts", params);
}

//活动列表
export function getactlist(params) {
  return axios.post("/realTimeInfo/listts", params);
}

//活动详情
export function getactlistgbits(params) {
  return axios.post("/realTimeInfo/gbits", params);
}

//产品列表
export function getproductItem(params) {
  return axios.post("/product/listts", params);
}

//产品罕见度
export function getproductRare(params) {
  return axios.post("/productRare/listts", params);
}

//产品系列，id数据
export function getproductSeries(params) {
  return axios.post("/productSeries/listts", params);
}

